import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import ENVIRONMENT from './environment';
import { globalProps } from './utils/globalProps';

if (ENVIRONMENT.DATADOG_APPLICATION_ID && ENVIRONMENT.DATADOG_CLIENT_TOKEN) {
  /**
   * Some configuration values must be matching between RUM and logs.
   * https://github.com/DataDog/browser-sdk/tree/2427f67053ca6041dd81eb565ea0d49483811f81/packages/logs#initialization-parameters
   */
  const datadogSharedConfig = {
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: ENVIRONMENT.PRODUCTION,
    useCrossSiteSessionCookie: ENVIRONMENT.PRODUCTION,
    allowedTracingUrls: [/http(s)?:\/\/((?!ctst))[^.]*(\.services)?\.bitrise\.(io|dev)/],
  };

  const datadogConfig = {
    ...datadogSharedConfig,
    clientToken: ENVIRONMENT.DATADOG_CLIENT_TOKEN,
    service: 'website',
    env: ENVIRONMENT.PRODUCTION ? 'production' : 'development',
    version: `v${ENVIRONMENT.WEBSITE_RELEASE_NUMBER}`,
    silentMultipleInit: true,
  };

  datadogRum.init({
    ...datadogConfig,
    applicationId: ENVIRONMENT.DATADOG_APPLICATION_ID,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    // Pin the pre-v7 defaults so the SDK upgrade is behaviour-neutral: v7 relaxed
    // Session Replay masking to 'mask-user-input', started masking action names, and
    // began propagating the `baggage` trace header (which needs CORS allow-listing).
    // 7.15 also turned on partial view updates (`view_update` events) without a proxy.
    betaEnableViewUpdates: false,
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: false,
    propagateTraceBaggage: false,
  });

  const { user, account } = globalProps;

  if (user) {
    datadogRum.setUser({
      id: user.slug,
      isCreditBased: user.isCreditBased,
      workspaceSlug: account ? account.slug : undefined,
    });
  }

  datadogLogs.init({
    ...datadogConfig,
    forwardConsoleLogs: 'all',
  });
}
